import { isThemingEnabled } from '@ms/acui-theme';
var modernUxExperimentPreference = false;
// Task 4473464 Clean-up 'ModernUxExperimentPreference' code from App Commanding UI Package
export var setModernUxExperimentPreference = function (isEnabled) {
    modernUxExperimentPreference = isEnabled;
};
export function getModernUxExperimentPreference() {
    return modernUxExperimentPreference && isThemingEnabled();
}
//# sourceMappingURL=ModernUxExperimentPreference.js.map